export default __webpack_public_path__ + "static/FASCIA - EXTERIOR CLADDING-d7612b0821849d34162f241b54bda287.webp";